import { DESKTOP_HD_MIN_WIDTH, DESKTOP_MIN_WIDTH, TABLET_MIN_WIDTH } from '../../constants/resolutions';
import GolosMediumWoff2 from 'shared/assets/fonts/GolosMedium.woff2';
import GolosRegularWoff2 from 'shared/assets/fonts/GolosRegular.woff2';
import { PaletteOptions } from '@material-ui/core/styles/createPalette';

import _ from 'lodash';
import { unstable_createMuiStrictModeTheme as createMuiTheme } from '@material-ui/core/styles';
import newPalette from './themePalette';

const fontGolos = {
  fontDisplay: 'swap' as const,
  fontFamily: 'Golos',
  fontStyle: 'normal',
  fontWeight: 400,
  src: `
    local('Golos'),
    local('Golos-Regular'),
    url(${GolosRegularWoff2}) format('woff2')
  `,
};

const fontGolosMedium = {
  fontDisplay: 'swap' as const,
  fontFamily: 'Golos',
  fontStyle: 'normal',
  fontWeight: 500,
  src: `
    local('Golos-Medium'),
    url(${GolosMediumWoff2}) format('woff2')
  `,
};

const commonTheme = {
  breakpoints: {
    values: {
      lg: DESKTOP_HD_MIN_WIDTH,
      md: DESKTOP_MIN_WIDTH,
      sm: TABLET_MIN_WIDTH,
      xl: 1920,
      xs: 0,
    },
  },
  commonColors: {
    blue: '#2E83D9',
    red: '#f44336',
  },
  typography: {
    fontFamily: 'Golos, Arial, sans-serif',
  },
};

const commonOverrides = {
  '@font-face': [fontGolos, fontGolosMedium],
  body: {
    fontSize: 14,
  },
  html: {
    fontSize: 14,
  },
};

const lightPalette = {
  backgrounds: {
    active: '#2E83D9',
    app: '#F2F2F2',
    block: '#FFFFFF',
    border: '#DADADA',
    chat_message: '#F7F9FA',
    disabled: '#D9E1E6',
    inactive: '#E9E9E9',
    popupMenu: '#FFFFFF',
    postHeader: '#dcdcdc',
    search: '#EFF2F3',
    searchBlock: '#FFFFFF',
    searchDetails: '#ffffff',
    searchInput: '#EFF2F3',
  },
  borderColors: {
    attached_file: '#EFF2F3',
    attached_link: '#CED8E1',
    form_border: '#000000',
    input_border: '#63ACF5',
  },
  iconColor: {
    color: '#000',
    modal: '#D8DAE3',
    modalBackground: '#FFFFFF',
  },
  textColors: {
    articleSubTitle: '#2F313D',
    articleTitle: '#262D5A',
    disabled: '#D4D4D4',
    groupInput: '#919191',
    keyWord: '#D9DBDE',
    labelInput: '#A7A8B1',
    link: '#1C8ED9',
    main: '#000000',
    profileLinks: '#1C8ED9',
    profileSubTitle: '#646568',
    profileTitle: '#3C3E4B',
    searchInputLabel: '#242424',
  },
  ...newPalette.light,
  type: 'light',
};

const darkPalette = {
  backgrounds: {
    active: '#2E83D9',
    app: '#242526',
    block: '#222335',
    border: '#616364',
    chat_message: '#333435',
    disabled: '#4E5051',
    inactive: '#4F5153',
    popupMenu: '#616364',
    postHeader: '#616364',
    search: '#3A3B3C',
    searchBlock: '#2F3031',
    searchDetails: '#424242',
    searchInput: '#505050',
  },
  borderColors: {
    attached_file: '#616364',
    attached_link: '#DFEFFF',
    form_border: '#ffffff',
    input_border: '#1C8ED9',
  },
  iconColor: {
    color: '#2E83D9',
    modal: '#C7C7C7',
    modalBackground: '#3A3B3C',
  },
  textColors: {
    articleSubTitle: '#ffffff',
    articleTitle: '#ffffff',
    disabled: '#D4D4D4',
    groupInput: '#ffffff',
    keyWord: '#3F4159',
    labelInput: '#ffffff',
    link: '#2E83D9',
    main: '#FFFFFF',
    profileLinks: '#ffffff',
    profileSubTitle: '#A7A8B1',
    profileTitle: '#ffffff',
    searchInputLabel: '#ffffff',
  },
  ...newPalette.dark,
  type: 'dark',
};

export const appThemes = [
  createMuiTheme({
    ...commonTheme,
    overrides: {
      MuiCssBaseline: {
        '@global': _.merge(commonOverrides, {
          body: {
            backgroundColor: lightPalette.backgroundColorsNew.app,
          },
        }),
      },
    },
    palette: lightPalette as PaletteOptions,
  }),
  createMuiTheme({
    ...commonTheme,
    overrides: {
      MuiCssBaseline: {
        '@global': _.merge(commonOverrides, {
          body: {
            backgroundColor: darkPalette.backgroundColorsNew.app,
          },
        }),
      },
    },
    palette: darkPalette as PaletteOptions,
  }),
];
